module.exports = __webpack_public_path__ + "static/media/goods_title_zh@3x.d02d4a9d.png";